import {MAP_TYPE} from './types';

export const getMap = data => ({
  type: MAP_TYPE,
  payload: data,
});
